const easyRounds = [
    {
      title: "Select the Trifecta",
      clue: "🏳️✌🏾",
      tiles: ["south_africa", "nigeria", "egypt", "kenya", "somalia", "ghana", "mauritius", "seychelles", "tunisia"],
      answer: ["nigeria", "somalia", "tunisia"],
      commonality: "They only have two colours on their flags!"
    },
    {
      title: "Select the Trifecta",
      clue: "🥐🗣️",
      tiles: ["nigeria", "kenya", "ivory_coast", "uganda", "senegal", "south_africa", "mali", "zambia", "ghana"],
      answer: ["ivory_coast", "senegal", "mali"],
      commonality: "These are French-speaking countries!"
    },
    {
      title: "Select the Trifecta",
      clue: "🏝️❌",
      tiles: ["mali", "mozambique", "kenya", "uganda", "nigeria", "ghana", "tanzania", "zambia", "senegal"],
      answer: ["mali", "uganda", "zambia"],
      commonality: "Hello Landlocked countries!"
    },
    {
      title: "Select the Trifecta",
      clue: "☕️🫘",
      tiles: ["nigeria", "ethiopia", "ivory_coast", "rwanda", "botswana", "south_africa", "libya", "zambia", "namibia"],
      answer: ["ivory_coast", "rwanda", "ethiopia"],
      commonality: "Countries that produce coffee!"
    },
    {
      title: "Select the Trifecta",
      clue: "🌊🚿✨",
      tiles: ["mauritania", "ethiopia", "ivory_coast", "angola", "gambia", "burkina_faso", "zimbabwe", "chad", "tunisia"],
      answer: ["zimbabwe", "angola", "ethiopia"],
      commonality: "Countries with famous waterfalls!"
    },
    {
      title: "Select the Trifecta",
      clue: "🐪🏜️",
      tiles: ["namibia", "malawi", "algeria", "uganda", "liberia", "sierra_leone", "togo", "burundi", "malawi"],
      answer: ["namibia", "algeria", "egypt"],
      commonality: "Countries with deserts !"
    },
  ];
  
  export default easyRounds;
  